module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GF-WRX.d8cd5595.webp";